export const defaultBrightness = 0;
export const defaultContrast = 0;
export const defaultColorMapSensitivity = 50;
export const defaultModifierSensitivity = 50;
export const defaultTeethSegmentationSensitivity = 50;
